/**
 * The report types a client or project can choose for the report sent automatically when an
 * inspection is completed (the Inspection Complete email's attachment). The values are the API's
 * (`inspectionNotificationService.getDefaultProps` builds each one); the client settings and the
 * project settings both list them from here.
 */
export const REPORT_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'entire_inspection', label: 'Entire Inspection' },
  { value: 'entire_inspection_wlocations', label: 'Entire Inspection W/Finding Location' },
  {
    value: 'entire_inspection_wlocations_wphotos',
    label: 'Entire Inspection W/Finding Location and Photos',
  },
  // SW2-2538
  {
    value: 'entire_inspection_wlocations_wlegend',
    label: 'Entire Inspection W/Finding Locations and Legend Items (Control Measures)',
  },
  {
    value: 'entire_inspection_wlocations_wphotos_wlegend',
    label:
      'Entire Inspection W/Finding Locations, Finding Images, and Legend Items (Control Measures)',
  },
  { value: 'ca_log_wophotos', label: 'Findings Log - Without Photos' },
  { value: 'ca_log_wphotos', label: 'Findings Log - With Photos' },
  { value: 'findings_wphotos', label: 'Open Findings Report - With Photos' },
];

/**
 * SW2-2538 — the types whose report can include the map changelog (`report_include_changelog`).
 * The API ignores the setting for every other type, so the checkbox is shown only for these.
 */
const CHANGELOG_REPORT_TYPES = new Set([
  'entire_inspection_wlocations_wlegend',
  'entire_inspection_wlocations_wphotos_wlegend',
]);

export const reportTypeOffersChangelog = (reportType: string | null | undefined): boolean =>
  !!reportType && CHANGELOG_REPORT_TYPES.has(reportType);

export const REPORT_INCLUDE_CHANGELOG_TOOLTIP =
  'When enabled, the automatically sent report also includes the map changelog.';
